"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DateQuickFilterValue () {
        return DateQuickFilterValue;
    },
    get FieldFilter () {
        return FieldFilter;
    },
    get FieldValue () {
        return FieldValue;
    },
    get FlexibleFieldFilter () {
        return FlexibleFieldFilter;
    },
    get GoalCategoriesObject () {
        return GoalCategoriesObject;
    },
    get GoalOutlookObject () {
        return GoalOutlookObject;
    },
    get GroupNameValue () {
        return GroupNameValue;
    },
    get GroupNames () {
        return GroupNames;
    },
    get IEmployeeStatusFilterValue () {
        return IEmployeeStatusFilterValue;
    },
    get QuickFilter () {
        return QuickFilter;
    },
    get ReportingSavedQueryDocument () {
        return ReportingSavedQueryDocument;
    },
    get ReviewCycleNameValue () {
        return ReviewCycleNameValue;
    },
    get ReviewCycleNames () {
        return ReviewCycleNames;
    },
    get ReviewFormNameValue () {
        return ReviewFormNameValue;
    },
    get ReviewFormNames () {
        return ReviewFormNames;
    },
    get ReviewReportSort () {
        return ReviewReportSort;
    },
    get ReviewReportStatusFilterValue () {
        return ReviewReportStatusFilterValue;
    },
    get ReviewStatusFilterValue () {
        return ReviewStatusFilterValue;
    },
    get StatusQuickFilterValue () {
        return StatusQuickFilterValue;
    },
    get SummaryColumnMetadata () {
        return SummaryColumnMetadata;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _enums = require("./enums");
const ReviewReportSort = _zod.z.object({
    name: _zod.z.string(),
    direction: _zod.z.enum([
        "asc",
        "desc"
    ]),
    fieldPath: _zod.z.array(_zod.z.string()),
    type: _zod.z.enum([
        "EMPLOYEE_FIELD",
        "GOAL_FIELD",
        "REVIEW_FIELD",
        "REVIEW_FORM_FIELD",
        "UNIQUE_QUESTION",
        "GROUPED_QUESTION",
        "REVIEW_CYCLE_FIELD",
        "SUBJECT",
        "SURVEY_FIELD"
    ])
});
const FieldValue = _zod.z.union([
    _zod.z.string(),
    _zod.z.instanceof(_bson.ObjectId),
    _zod.z.date(),
    _zod.z.boolean(),
    _zod.z.array(_zod.z.union([
        _zod.z.string(),
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.date()
    ]))
]).nullable();
const OldSelectValue = _zod.z.object({
    value: FieldValue,
    label: _zod.z.string()
});
const FlexibleFieldFilter = _zod.z.object({
    value: FieldValue.or(OldSelectValue).or(OldSelectValue.array()),
    field: _zod.z.string().or(OldSelectValue),
    comparison: _enums.FilterComparisonEnum,
    type: _enums.FieldTypeEnum,
    isCustomField: _zod.z.boolean().optional(),
    category: _enums.FieldCategory.optional()
});
const FieldFilter = _zod.z.object({
    value: FieldValue,
    field: _zod.z.string(),
    comparison: _enums.FilterComparisonEnum,
    type: _enums.FieldTypeEnum,
    isCustomField: _zod.z.boolean().optional(),
    category: _enums.FieldCategory.optional()
});
const DateQuickFilterValue = _zod.z.object({
    start: _zod.z.union([
        _zod.z.string(),
        _zod.z.date()
    ]),
    end: _zod.z.union([
        _zod.z.string(),
        _zod.z.date()
    ])
});
const ReviewStatusFilterValue = _zod.z.object({
    value: _zod.z.array(_enums.ReviewStatusFiltersEnum)
});
const IEmployeeStatusFilterValue = _zod.z.object({
    value: _zod.z.array(_enums.EmployeeStatusFiltersEnum)
});
const ReviewReportStatusFilterValue = _zod.z.object({
    value: _zod.z.array(_enums.ReviewReportStatusFiltersEnum)
});
const ReviewCycleNameValue = _zod.z.object({
    value: _zod.z.string(),
    label: _zod.z.string()
});
const ReviewFormNameValue = _zod.z.object({
    value: _zod.z.string(),
    label: _zod.z.string()
});
const GroupNameValue = _zod.z.object({
    value: _zod.z.string(),
    label: _zod.z.string()
});
const ReviewCycleNames = _zod.z.object({
    value: _zod.z.array(ReviewCycleNameValue),
    options: _zod.z.array(ReviewCycleNameValue)
});
const ReviewFormNames = _zod.z.object({
    value: _zod.z.array(ReviewFormNameValue),
    options: _zod.z.array(ReviewFormNameValue)
});
const GroupNames = _zod.z.object({
    value: _zod.z.array(GroupNameValue),
    options: _zod.z.array(GroupNameValue)
});
const StatusQuickFilterValue = _zod.z.object({
    value: _zod.z.array(_zod.z.string())
});
const QuickFilter = _zod.z.object({
    type: _enums.QuickFilterType.or(_zod.z.string()),
    value: _zod.z.any()
});
const SummaryColumnMetadata = _zod.z.object({
    isColumnVisible: _zod.z.boolean(),
    currentlySelectedSummaryFunction: _enums.SummaryFunctionEnum,
    availableSummaryFunctions: _zod.z.array(_enums.SummaryFunctionEnum)
});
const ReportingSavedQueryDocument = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    type: _enums.ReportingType,
    company_id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    description: _zod.z.string().optional(),
    filters: _zod.z.array(_zod.z.array(FlexibleFieldFilter)),
    additional_filters: _zod.z.array(_zod.z.array(FieldFilter)).optional(),
    employee_query_id: _zod.z.instanceof(_bson.ObjectId).nullable(),
    question_grouping_session_id: _zod.z.instanceof(_bson.ObjectId),
    selected_data_fields: _zod.z.array(_zod.z.string()),
    tags: _zod.z.array(_zod.z.string()).default([]),
    sorts: ReviewReportSort.array(),
    selectedColumns: _zod.z.array(_zod.z.string()).or(_zod.z.null()),
    columnMetadata: _zod.z.record(_zod.z.string(), _zod.z.object({
        width: _zod.z.number()
    })).or(_zod.z.null()),
    summarizeBy: _zod.z.array(_zod.z.string()),
    aggregationOperations: _zod.z.array(_zod.z.object({
        type: _zod.z.string(),
        name: _zod.z.string(),
        operation: _zod.z.string()
    })).optional(),
    isSummarizeRowsView: _zod.z.boolean(),
    quickFilter: QuickFilter.or(_zod.z.array(QuickFilter)),
    createdBy: _zod.z.instanceof(_bson.ObjectId).or(_zod.z.string()).nullish(),
    createdAt: _zod.z.date(),
    updatedAt: _zod.z.date(),
    deletedAt: _zod.z.date().nullable().optional(),
    showAllAggregationColumns: _zod.z.boolean().optional(),
    summaryColumnMetadata: _zod.z.record(_zod.z.string(), SummaryColumnMetadata),
    summarizeByMetadata: _zod.z.record(_zod.z.string(), _zod.z.object({
        selection: _zod.z.string().optional()
    })).optional(),
    sharedWith: _zod.z.array(_zod.z.string()).optional()
});
const GoalOutlookObject = _zod.z.object({
    color: _zod.z.string(),
    id: _zod.z.string(),
    name: _zod.z.string()
});
const GoalCategoriesObject = _zod.z.object({
    label: _zod.z.string(),
    value: _zod.z.string()
});
